(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import moment from 'moment';
import { ProfileManager } from '@kailona/core';

function mapToFHIRBodyWeight(physicalData) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var date = physicalData.date,
      bodyWeight = physicalData.bodyWeight;

  if (!date || !bodyWeight) {
    return null;
  }

  var observation = {
    resourceType: 'Observation',
    status: 'final',
    category: [{
      coding: [{
        system: 'http://hl7.org/fhir/ValueSet/observation-category',
        code: 'vital-signs',
        display: 'Vital Signs'
      }]
    }],
    code: {
      coding: [{
        system: 'http://loinc.org',
        code: '29463-7',
        display: 'Body Weight'
      }],
      text: 'Body Weight'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    },
    effectiveDateTime: moment(date).utc().toISOString(),
    valueQuantity: {
      value: parseInt(bodyWeight, 10),
      unit: 'kg',
      system: 'http://unitsofmeasure.org',
      code: 'kg'
    }
  };
  var idMap = physicalData.idMap;

  if (idMap && idMap.bodyWeight) {
    observation.id = idMap.bodyWeight;
  }

  return observation;
}

function mapToFHIRBodyHeight(physicalData) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var date = physicalData.date,
      bodyHeight = physicalData.bodyHeight;

  if (!date || !bodyHeight) {
    return null;
  }

  var observation = {
    resourceType: 'Observation',
    status: 'final',
    category: [{
      coding: [{
        system: 'http://hl7.org/fhir/ValueSet/observation-category',
        code: 'vital-signs',
        display: 'Vital Signs'
      }]
    }],
    code: {
      coding: [{
        system: 'http://loinc.org',
        code: '8302-2',
        display: 'Body height'
      }],
      text: 'Body height'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    },
    effectiveDateTime: moment(date).utc().toISOString(),
    valueQuantity: {
      value: parseInt(bodyHeight, 10),
      unit: 'cm',
      system: 'http://unitsofmeasure.org',
      code: 'cm'
    }
  };
  var idMap = physicalData.idMap;

  if (idMap && idMap.bodyHeight) {
    observation.id = idMap.bodyHeight;
  }

  return observation;
}

function mapToFHIRBMI(physicalData, observationIds) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var date = physicalData.date,
      bmi = physicalData.bmi;

  if (!date || !bmi) {
    return null;
  }

  var observation = {
    resourceType: 'Observation',
    status: 'final',
    category: [{
      coding: [{
        system: 'http://hl7.org/fhir/ValueSet/observation-category',
        code: 'vital-signs',
        display: 'Vital Signs'
      }]
    }],
    code: {
      coding: [{
        system: 'http://loinc.org',
        code: '39156-5',
        display: 'Body mass index (BMI) [Ratio]'
      }],
      text: 'Body mass index (BMI)'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    },
    effectiveDateTime: moment(date).utc().toISOString(),
    valueQuantity: {
      value: parseFloat(bmi),
      unit: 'kg/m2',
      system: 'http://unitsofmeasure.org',
      code: 'kg/m2'
    }
  };

  if (observationIds && observationIds.length) {
    observation.derivedFrom = observationIds.map(function (observationId) {
      return {
        reference: "Observation/".concat(observationId)
      };
    });
  }

  var idMap = physicalData.idMap;

  if (idMap && idMap.bmi) {
    observation.id = idMap.bmi;
  }

  return observation;
}

function mapToFHIRPhysicalDataPanel(physicalData, observationIds) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var date = physicalData.date;

  if (!date || !observationIds || !observationIds.length) {
    return null;
  }

  var observation = {
    resourceType: 'Observation',
    status: 'final',
    category: [{
      coding: [{
        system: 'http://hl7.org/fhir/ValueSet/observation-category',
        code: 'vital-signs',
        display: 'Vital Signs'
      }]
    }],
    code: {
      coding: [{
        system: 'http://loinc.org',
        code: '34565-2',
        display: 'Vital signs, weight and height panel'
      }],
      text: 'Vital signs panel including weight, height and BMI'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    },
    effectiveDateTime: moment(date).utc().toISOString(),
    hasMember: observationIds.map(function (observationId) {
      return {
        reference: "Observation/".concat(observationId)
      };
    })
  };
  var idMap = physicalData.idMap;

  if (idMap && idMap.panel) {
    observation.id = idMap.panel;
  }

  return observation;
}

export { mapToFHIRBodyWeight, mapToFHIRBodyHeight, mapToFHIRBMI, mapToFHIRPhysicalDataPanel };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(mapToFHIRBodyWeight, "mapToFHIRBodyWeight", "/home/runner/html/nextcloud/apps/ehr/js/plugins/physicalData/src/mappers/mapToFHIR.js");
  reactHotLoader.register(mapToFHIRBodyHeight, "mapToFHIRBodyHeight", "/home/runner/html/nextcloud/apps/ehr/js/plugins/physicalData/src/mappers/mapToFHIR.js");
  reactHotLoader.register(mapToFHIRBMI, "mapToFHIRBMI", "/home/runner/html/nextcloud/apps/ehr/js/plugins/physicalData/src/mappers/mapToFHIR.js");
  reactHotLoader.register(mapToFHIRPhysicalDataPanel, "mapToFHIRPhysicalDataPanel", "/home/runner/html/nextcloud/apps/ehr/js/plugins/physicalData/src/mappers/mapToFHIR.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();